"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useElementEnteredViewport = void 0;
const react_1 = require("react");
function reducer() {
    return true;
}
function useElementEnteredViewport(options = {}) {
    const { enable = true } = options, intersectionOptions = __rest(options, ["enable"]);
    const refEl = (0, react_1.useRef)(null);
    const [entered, enter] = (0, react_1.useReducer)(reducer, 
    // Always entered = true on SSR
    typeof window === 'undefined');
    (0, react_1.useEffect)(function viewportEnteredObserver() {
        if (!enable || entered)
            return;
        const el = refEl.current;
        if (!el || typeof IntersectionObserver === 'undefined') {
            return;
        }
        function intersectionCallback(entries) {
            entries.forEach(entry => {
                if (entry.isIntersecting || entry.intersectionRatio > 0) {
                    enter();
                }
            });
        }
        const observer = new IntersectionObserver(intersectionCallback, Object.assign({ threshold: 0 }, intersectionOptions));
        observer.observe(el);
        return function cleanup() {
            observer.disconnect();
        };
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [entered, enable]);
    return {
        entered,
        refEl,
        force: enter,
    };
}
exports.useElementEnteredViewport = useElementEnteredViewport;
//# sourceMappingURL=use-element-entered-viewport.js.map